import request from '../request';
import { API_URL } from '../../utils/constants';
import { ContractorUniquenessRequestDto } from '../../types/GetContractorDuplicateDto';

export default {
  isUniqueForCreate: async (values: ContractorUniquenessRequestDto) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/contractors/is-unique-for-create`, 'post', body);
  },

  isUniqueForUpdate: async (type: string, id: string, values: ContractorUniquenessRequestDto) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/contractors/is-unique-for-update/${type}/${id}`, 'post', body);
  }
}